module.exports = __webpack_public_path__ + "static/media/clock.aab0e46a.svg";